"use client";
import React, { useEffect } from "react";
import { useSearchParams } from "next/navigation";
import { Heading, Stack, Divider } from "@chakra-ui/react";
import { scrollToElement } from "@/utils/scrollToElement";
import TalkToUs from "app/components/shared/talkToUs";
import CustomCarousel from "app/components/shared/CustomCarousel";
import Certificates from "app/components/views/home/Certificates";
import ProgramDetails from "app/components/shared/ProgramDetails";
import Features from "app/components/views/homefeatures/features";
import SecurityAchievements from "./components/ourAchievements";

const AboutUsPage = () => {
  const searchParams = useSearchParams();
  const section = searchParams.get("section");
  useEffect(() => {
    if (section) {
      scrollToElement(section, 120);
    }
  }, [section]);
  return (
    <>
      <Stack spacing={8} mt={12}>
        <Heading as="h1" textAlign="center" data-cy={"section-header"}>
          About Us
          <Divider
            width={"50px"}
            borderBottomWidth={"2px"}
            borderBottomColor={"black"}
            mx="auto"
          />
        </Heading>
      </Stack>
      <ProgramDetails type={"about-us"} title={"Our Mission and Vision"} />
      <SecurityAchievements />
      <Features />
      <Certificates />
      <CustomCarousel />
      <TalkToUs />
    </>
  );
};

export default AboutUsPage;
